/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Report } from '../../models/report';

export interface ReportsGetReportTypeList$Params {
  reportType?: number;
}

export function reportsGetReportTypeList(http: HttpClient, rootUrl: string, params?: ReportsGetReportTypeList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Report>>> {
  const rb = new RequestBuilder(rootUrl, reportsGetReportTypeList.PATH, 'get');
  if (params) {
    rb.query('reportType', params.reportType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Report>>;
    })
  );
}

reportsGetReportTypeList.PATH = '/api/Reports/report/reportTypeList';
